/**
 * 流动动画
 */
import fvAnimation from "./fvAnimation"
export default class fvFlow extends fvAnimation {
    constructor(shape) {
        super(shape, "fvFlow");
        this.flowOffset = 0;
        this.speedControl = 0;
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.result = 0;
        this.width *= this.shape.magnification.x;
        this.height *= this.shape.magnification.y;
        this.getData();
    }

    async getData() {
        this.result = await this.executionScript(this.sizeFunction);
    }

    drawFlowPtToPt(pt1, pt2, canvas, flowOffset, color, width, height, space, speed, scale) {
        var p1, p2;
        if (Number(scale)) {
            p1 = pt2;
            p2 = pt1;
        } else {
            p1 = pt1;
            p2 = pt2;
        }
        canvas.lineCap = "square";
        canvas.strokeStyle = color;
        canvas.lineWidth = height;
        canvas.beginPath();

        var bHorFlow;
        if (Math.abs(p2.x - p1.x) > Math.abs(p2.y - p1.y)) {
            bHorFlow = true;
        } else {
            bHorFlow = false;
        }

        var chord = Math.sqrt((
            (p2.x - p1.x) * (p2.x - p1.x) +
            (p2.y - p1.y) * (p2.y - p1.y))
        );
        var sine = (p2.y - p1.y) / Math.max(1, chord);
        var cosine = (p2.x - p1.x) / Math.max(1, chord);

        var w = width;
        //var h = 5;

        var sp = space;//GetFlowSpace();
        var sp_x = sp * cosine;
        var sp_y = sp * sine;
        var step_x = (w + sp) * cosine;
        var step_y = (w + sp) * sine;
        var w_x = w * cosine;
        var w_y = w * sine;

        var offset = (w + sp) * (flowOffset) / 5;
        var off_x = (offset * cosine);
        var off_y = (offset * sine);

        if (Math.abs(offset) > Math.abs(sp)) {
            canvas.moveTo(p1.x, p1.y);
            canvas.lineTo(p1.x + off_x - sp_x, p1.y + off_y - sp_y);
        }

        var x = p1.x + off_x - step_x;
        var y = p1.y + off_y - step_y;
        if (bHorFlow) {
            var cmpX;

            if (step_x > 0) {
                cmpX = function (x1, x2) {
                    return x1 - x2;
                };
            } else {
                cmpX = function (x1, x2) {
                    return x2 - x1;
                };
            }

            for (var i = 0;
                ;
                i++) {
                x += step_x;
                y += step_y;
                canvas.moveTo(x, y);
                if (cmpX(x, p2.x) < 0) {
                    if (cmpX(x + w_x, p2.x) < 0) {
                        canvas.lineTo(x + w_x, y + w_y);
                    } else {
                        canvas.lineTo(p2.x, p2.y);
                        break;
                    }
                } else {
                    break;
                }
            }
        }
        else {
            var cmpY;

            if (step_y > 0) {
                cmpY = function (y1, y2) {
                    return y1 - y2;
                };
            } else {
                cmpY = function (y1, y2) {
                    return y2 - y1;
                };
            }

            for (var i = 0;
                ;
                i++) {
                x += step_x;
                y += step_y;
                canvas.moveTo(x, y);
                if (cmpY(y, p2.y) < 0) {
                    if (cmpY(y + w_y, p2.y) < 0) {
                        canvas.lineTo(x + w_x, y + w_y);
                    } else {
                        canvas.lineTo(p2.x, p2.y);
                        break;
                    }
                } else {
                    break;
                }
            }
        }
        canvas.stroke(); 
    }

    run(canvas,value) {
        //禁止
        // if(value == false) {
        //     return
        // }else{
            this.getData();
            if (this.result) {
                this.speedControl++;
                if (this.speedControl > 6) this.speedControl = 1;
                if (!(this.speedControl % (3 - this.speed))) {
                        this.flowOffset++;
                    if (this.flowOffset > 4) this.flowOffset = 0;
                }
            } else {
                this.speedControl++;
                if (this.speedControl > 6) this.speedControl = 1;
                if (!(this.speedControl % (3 - this.speed))) {
                        this.flowOffset = 0;
                    if (this.flowOffset > 4) this.flowOffset = 0;
                }
                
            }
        // }
        
    }
    runEnd(canvas) {
        if(this.result || !parseInt(this.showOnFlowing)){
            //显示流动
            if (this.shape.fctype == "fvLineObj") {
                //判断是否组内图元
                var p1 = {
                    x: this.shape.start.x,
                    y: this.shape.start.y,
                };
                var p2 = {
                    x: this.shape.end.x,
                    y: this.shape.end.y,
                };
                this.drawFlowPtToPt(p1, p2, canvas, this.flowOffset, this.color, this.width, this.height, this.space, this.speed, this.scale);
                //pipeObj是判断添加对管道的流动属性添加
            } else if (this.shape.fctype == "fvPolylineObj" || this.shape.fctype == "fvPipeObj") {
                //判断是否存在拐角后重新计算点位置
                if (this.shape.pPotPtr) {
                    for (var i = 0; i < this.shape.pPotPtr.length - 1; i++) {
                        var p1 = {
                            x: this.shape.cx + this.shape.pPotPtr[i]["x"],
                            y: this.shape.cy + this.shape.pPotPtr[i]["y"],
                        };
                        var p2 = {
                            x: this.shape.cx + this.shape.pPotPtr[i + 1]["x"],
                            y: this.shape.cy + this.shape.pPotPtr[i + 1]["y"],
                        };
                        this.drawFlowPtToPt(p1, p2, canvas, this.flowOffset, this.color, this.width, this.height, this.space, this.speed, this.scale);
                    }
                } else {
                    for (var i = 0; i < this.shape.m_points.length - 1; i++) {
                        var p1 = {
                            x: this.shape.cx + this.shape.m_points[i]["x"],
                            y: this.shape.cy + this.shape.m_points[i]["y"],
                        };
                        var p2 = {
                            x: this.shape.cx + this.shape.m_points[i + 1]["x"],
                            y: this.shape.cy + this.shape.m_points[i + 1]["y"],
                        };
                        this.drawFlowPtToPt(p1, p2, canvas, this.flowOffset, this.color, this.width, this.height, this.space, this.speed, this.scale);
                    }
                }
            }
        }
            
        
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvFlow.js